module.exports = __webpack_public_path__ + "static/media/news__placeholder.a3b8beb0.jpg";